import { render, staticRenderFns } from "./agreementJk.vue?vue&type=template&id=a831b4de&scoped=true"
var script = {}
import style0 from "./agreementJk.vue?vue&type=style&index=0&id=a831b4de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a831b4de",
  null
  
)

export default component.exports